import PageShell from "@/components/PageShell";
import PageHero from "@/components/PageHero";
import TokenUtility from "@/components/TokenUtility";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const FLOW = [
    "Users pay $DCX",
    "Workloads run on nodes",
    "Nodes earn $DCX",
    "Validators secure consensus",
    "Developers receive revenue share",
    "Treasury funds growth",
    "Burn reduces supply",
];

export default function TokenPage() {
    return (
        <PageShell>
            <PageHero
                eyebrow="$DCX"
                title="$DCX Powers the"
                accent="DeCloudX Infrastructure Economy."
                sub="$DCX is the native gas, settlement, staking, incentive, and governance asset of the DeCloudX network. Utility-first by design — not a speculative instrument."
            />

            <TokenUtility />

            <section className="relative py-16 md:py-24 border-t border-line">
                <div className="max-w-7xl mx-auto px-6 md:px-10">
                    <div className="overline mb-3">Economic Flow</div>
                    <h2 className="font-heading font-black text-2xl sm:text-3xl text-ink max-w-3xl">Value flows where work happens.</h2>
                    <div className="mt-10 surface-strong rounded-2xl p-6 md:p-10">
                        <div className="flex flex-wrap items-center justify-center gap-3">
                            {FLOW.map((f, i) => (
                                <div key={i} className="flex items-center gap-3" data-testid={`flow-${i}`}>
                                    <div className="surface px-4 py-3 rounded-xl text-sm text-ink font-medium">{f}</div>
                                    {i < FLOW.length - 1 && <ArrowRight size={14} className="text-faint-ink" strokeWidth={2} />}
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="mt-10 surface p-6 rounded-2xl border border-line">
                        <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-faint-ink mb-2">Disclosure</div>
                        <p className="text-sm text-muted-ink leading-relaxed">
                            $DCX is described here purely in terms of network utility. No information on this page constitutes investment advice, a price forecast, or an offer to sell or solicit securities. Always consult appropriate counsel and your local regulations.
                        </p>
                    </div>

                    <div className="mt-12 flex flex-wrap gap-3">
                        <Link to="/whitepaper" className="btn-primary">Learn $DCX Utility <ArrowRight size={15} strokeWidth={2} /></Link>
                        <Link to="/contact?role=partner" className="btn-secondary">Talk to Foundation</Link>
                    </div>
                </div>
            </section>
        </PageShell>
    );
}
